export class Organisation {
	public constructor(public id: string, public name: string) {}
}
